import React, { useState, useEffect, useContext } from "react";
import Media from "react-media";
import { withTheme, ThemeContext } from "styled-components";
export const withDefaultMedia = WrappedComponent => {
  return withTheme(props => {
    return /*#__PURE__*/React.createElement(Media, {
      queries: props.theme.media
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  });
};
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);

    const listener = () => {
      setMatches(media.matches);
    };

    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [query]);
  return matches;
}
export const useIsMobile = () => {
  const {
    media: {
      small
    }
  } = useContext(ThemeContext);
  return useMediaQuery(small);
};